import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModalComponent } from 'app/core/modal.component';
import { FilterList } from 'app/entities/filter.entity';
import { TabsComponent } from 'app/components/ui/tabs/item';
import {SwitchCheckboxCollection} from 'app/entities/switchCollection.entity';

@Component({
  selector: 'app-filter-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class FilterModalComponent extends ModalComponent implements OnInit, AfterViewInit {

  @ViewChild('tabsComponent') tabsComponent: TabsComponent;
  contentLoading = true;
  search = false;
  searchInput: string = null;
  title = 'Фильтры';


  filterData: FilterList;
  filterCopyData: FilterList;

  constructor(
    modalController: ModalController
  ) {
    super(modalController);
    this.filterCopyData = new FilterList([]);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  ionViewWillEnter() {
    this.filterCopyData.items.push(...this.filterData.makeCloneItems().items);
  }
  searchChange() {
    this.filterCopyData.items.forEach(filter => {
      const collection = filter.itemCollection;
      let findOne = false;
      collection?.items?.forEach((item) => {
        if (item.subCollection?.items?.length && collection instanceof SwitchCheckboxCollection) {
          const descendants = collection.getDescendants(item);
          descendants.forEach(child => {
            if (this.searchInput) {
              child.visible = child.title.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1;
            } else {
              child.visible = true;
            }
          });
        } else {
          if (this.searchInput) {
            item.visible = item.title.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1;
          } else {
            item.visible = true;
          }
        }

        findOne = (this.searchInput.toLowerCase() === item.title.toLowerCase()) || findOne;
      });
    });
  }

  clearAndClose() {
    this.filterCopyData.items.forEach(filter => filter.itemCollection.deSelectAll());
    this.acceptAndClose();
  }

  acceptAndClose() {
    const data = this.filterCopyData.items.map(item => {
      if (item.itemCollection instanceof SwitchCheckboxCollection) {
        item.itemCollection.getConvertedSubCollectionToSwitchItem();
      } else {
        item.itemCollection.items.forEach(itemc => {
          itemc.visible = true;
        });
      }
      return {
        ...item,
        itemCollection: item.itemCollection.makeClone()
      };
    });
    return super.closeModal({filterData: data});
  }


  ready() {
    setTimeout(() => {
      this.tabsComponent.updateHeight(0);
      this.contentLoading = false;
    }, 200);
  }

  asCheckbox(item): SwitchCheckboxCollection {
    return item.itemCollection;
  }
}


